<template>
  <div class="pagination">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="pageSizes || PAGE_SIZES" :page-size="pageSize" :layout="layout || PAGE_LAYOUT" :total="total"
      :background="background || true">
    </el-pagination>
  </div>
</template>

<script>
import config from "../config/index";

export default {
  name: "Pagination",
  props: {
    currentPage: Number,
    pageSize: Number,
    total: Number,
    pageSizes: Array,
    layout: String,
    background: Boolean,
  },
  data() {
    return {
      PAGE_SIZES: config.PAGE_SIZES,
      PAGE_LAYOUT: "prev, pager, next, sizes, total, jumper",
      // PAGE_LAYOUT: "prev, pager, next, jumper, total, sizes",
    };
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.$emit("onSizeChange", val);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.$emit("onCurrentChange", val);
    },
  },
};
</script>

<style lang="less" scoped>
.pagination {
  margin-top: 30px;
  margin-bottom: 40px;
  text-align: center;
  /deep/ .el-pagination__jump {
    margin: 0 10px;
  }
}
</style>
